import { render, staticRenderFns } from "./tab_work.vue?vue&type=template&id=507d9b67&scoped=true&"
import script from "./tab_work.vue?vue&type=script&lang=js&"
export * from "./tab_work.vue?vue&type=script&lang=js&"
import style0 from "./tab_work.vue?vue&type=style&index=0&id=507d9b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d9b67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507d9b67')) {
      api.createRecord('507d9b67', component.options)
    } else {
      api.reload('507d9b67', component.options)
    }
    module.hot.accept("./tab_work.vue?vue&type=template&id=507d9b67&scoped=true&", function () {
      api.rerender('507d9b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/work/tab_work.vue"
export default component.exports